import { Box } from '@mui/system';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useCallback } from 'react';
import type { OpenXAgentToolData } from '../../context/OpenXAgentContext.ts';
import { useOpenXAgentContext } from '../../context/useOpenXAgentContext.ts';
import { getOpenXAgentGradient } from '../colors.ts';
import type { OpenXAgentTool } from '../Home/utils/consts.ts';
import { OpenXAgentIcon } from '../icons/OpenXAgentIcon.tsx';

type ToolCallButtonProps = {
  isAllowed: boolean;
  isLoading: boolean;
  toolId: OpenXAgentTool;
  toolData: OpenXAgentToolData;
  name: string;
  dataTest?: string;
};

export const ToolCallButton = ({ isAllowed, isLoading, toolId, toolData, name, dataTest }: ToolCallButtonProps) => {
  const { setActiveTool, setIsOpenXAgentOpen } = useOpenXAgentContext();

  const handleClick = useCallback(() => {
    setActiveTool({
      toolId: toolId,
      toolData: toolData,
    });
    setIsOpenXAgentOpen(true);
  }, [setActiveTool, setIsOpenXAgentOpen, toolId, toolData]);

  if (!isAllowed) return null;

  return (
    <Button
      loading={isLoading}
      onClick={handleClick}
      {...(dataTest && { 'data-test': dataTest })}
      startIcon={
        <Box sx={{ mb: 0.25 }}>
          <OpenXAgentIcon width={16} height={16} />
        </Box>
      }
      sx={{ background: theme => getOpenXAgentGradient(theme) }}
    >
      {name}
    </Button>
  );
};
